import { Skeleton } from "antd";
import React from "react";
import { NotFound } from "../../../app/pages/NotFound";

interface Props {
  children: React.ReactNode;
  itemLoaded: boolean;
  isError?: boolean;
}

const DisplayWrapper = (props: Props) => {
  // A failed background refetch keeps the item it already loaded - only an item that never loaded is not found.
  if (props.isError && !props.itemLoaded) {
    return <NotFound />;
  }

  if (props.itemLoaded) {
    return <>{props.children}</>;
  }

  return (
    <>
      <Skeleton active paragraph={{ rows: 6 }} />
      <Skeleton active paragraph={{ rows: 3 }} />
      <Skeleton active paragraph={{ rows: 2 }} />
    </>
  );
};

export default DisplayWrapper;
